import React from "react";

/**
 * Guild Capital — official logo.
 * Uses the recolored (gold, transparent BG) PNG served from /public.
 */
export const GuildCapitalLogo = ({ size = 220, className = "", alt = "Guild Capital" }) => {
    return (
        <img
            src="/guild-capital-logo.png"
            alt={alt}
            data-testid="guild-capital-logo"
            className={className}
            style={{
                height: size,
                width: "auto",
                display: "block",
                userSelect: "none",
                pointerEvents: "none",
            }}
            draggable={false}
        />
    );
};

export default GuildCapitalLogo;
